import { X } from "lucide-react";
import { useGuidesStore } from "@/stores/useGuidesStore";
import { getWalkthrough } from "@/lib/guideRegistry";

export function SoonStubOverlay() {
  const openWalkthroughId = useGuidesStore((s) => s.openWalkthroughId);
  const openWalkthrough = useGuidesStore((s) => s.openWalkthrough);
  const closeWalkthrough = useGuidesStore((s) => s.closeWalkthrough);

  if (!openWalkthroughId) return null;
  const walkthrough = getWalkthrough(openWalkthroughId);
  if (!walkthrough || walkthrough.content.status !== "soon") return null;

  const liveRelated = (walkthrough.relatedWalkthroughs ?? [])
    .map((id) => getWalkthrough(id))
    .filter((w): w is NonNullable<typeof w> => !!w && w.content.status === "live");

  return (
    <div className="p-6 text-left">
      <div className="mb-3 flex items-start justify-between">
        <div>
          <h3 className="text-lg font-bold text-guide-text">{walkthrough.content.label}</h3>
          {walkthrough.content.tagline && (
            <p className="mt-0.5 text-xs text-guide-text-muted">{walkthrough.content.tagline}</p>
          )}
        </div>
        <button
          type="button"
          aria-label="Close walkthrough"
          onClick={closeWalkthrough}
          className="text-guide-text-faint hover:text-guide-text-soft"
        >
          <X className="size-5" />
        </button>
      </div>

      <div className="mt-4 rounded-lg border border-amber-200 bg-amber-100 p-4">
        <div className="mb-2 text-sm font-medium text-amber-900">
          This chapter is in progress.
        </div>

        {walkthrough.content.plannedSections && walkthrough.content.plannedSections.length > 0 && (
          <>
            <div className="mt-3 text-xs font-semibold uppercase tracking-wide text-amber-800">
              Planned sections
            </div>
            <ul className="mt-1 list-disc pl-5 text-xs text-amber-900">
              {walkthrough.content.plannedSections.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ul>
          </>
        )}
      </div>

      {liveRelated.length > 0 && (
        <div className="mt-4">
          <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-guide-text-muted">
            Available now
          </div>
          <div className="space-y-1">
            {liveRelated.map((w) => (
              <button
                key={w.id}
                type="button"
                onClick={() => openWalkthrough(w.id)}
                className="block text-left text-sm text-purple-600 hover:text-purple-800"
              >
                → {w.content.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
